// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetMembershipDetailRequestModel from '../../model/get-membership-detail-request-model';
import GetMembershipDetailRequestDTO from '../dto/get-membership-detail-request-dto';
import dtoSchema from '../schemas/get-membership-detail-request-schema';

export default abstract class GetMembershipDetailRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetMembershipDetailRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetMembershipDetailRequestDTO>): GetMembershipDetailRequestModel;
  static toModel(dto: DeepPartial<GetMembershipDetailRequestDTO> | undefined | null): GetMembershipDetailRequestModel | undefined;
  static toModel(dto: DeepPartial<GetMembershipDetailRequestDTO> | undefined | null): GetMembershipDetailRequestModel | undefined {
    return dto ? new GetMembershipDetailRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetMembershipDetailRequestModel> | GetMembershipDetailRequestModel): GetMembershipDetailRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetMembershipDetailRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetMembershipDetailRequestModel, can not map to GetMembershipDetailRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
